import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { SentFromEmailState } from "@redotech/redo-return-ui/flows/rules/conditions/sent-from-email";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useState } from "react";

export const SentFromEmailDetails = memo(function SentFromEmailDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<SentFromEmailState>) {
  const [inputValue, setInputValue] = useState("");

  const matchModeOptions = [
    {
      id: "INCLUDES",
      type: "text" as const,
      text: "Email contains",
      value: "INCLUDES",
    },
    {
      id: "IS_EXACTLY",
      type: "text" as const,
      text: "Email matches exactly",
      value: "IS_EXACTLY",
    },
  ];

  const selectedMatchMode = matchModeOptions.find(
    (option) => option.id === state.matchMode,
  );

  return (
    <>
      <RedoTagInputField
        inputValue={inputValue}
        label="Sender email address(es)"
        placeholder="Enter email addresses"
        setInputValue={setInputValue}
        setTags={(emails) => {
          const uniqueEmails = Array.from(new Set(emails));
          setState({ ...state, emails: uniqueEmails as typeof state.emails });
        }}
        state={disabled ? "disabled" : "default"}
        tags={state.emails.map((email) => ({ text: email }))}
      />
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        label="Match mode"
        options={matchModeOptions}
        optionSelected={({ item }) => {
          setState({ ...state, matchMode: item.id as typeof state.matchMode });
        }}
        selectedItem={selectedMatchMode}
      />
    </>
  );
});
